import {Component} from '@angular/core';
import {DialogRef} from "@progress/kendo-angular-dialog";

@Component({
  selector: 'app-modal-confirmacao',
  templateUrl: './modal-confirmacao.component.html',
  styleUrls: ['./modal-confirmacao.component.scss']
})
export class ModalConfirmacaoComponent {
  titulo: string = 'Confirmação';
  mensagem: string = 'Deseja confirmar esta ação?';
  textoConfirmacao: string = 'Confirmar';
  textoCancelamento: string = 'Cancelar';
  tipoConfirmacao: 'primary' | 'danger' | 'warning' | 'info' = 'primary';

  constructor(private dialogRef: DialogRef) {}

  confirmar() {
    this.dialogRef.close({ confirmado: true });
  }

  cancelar() {
    this.dialogRef.close({ confirmado: false });
  }

  getClasseBotao(): string {
    switch (this.tipoConfirmacao) {
      case 'danger':
        return 'btn-danger';
      case 'warning':
        return 'btn-warning';
      case 'info':
        return 'btn-info';
      default:
        return 'btn-primary';
    }
  }

  getIcone(): string {
    switch (this.tipoConfirmacao) {
      case 'danger':
        return 'fa-exclamation-triangle';
      case 'warning':
        return 'fa-exclamation-circle';
      case 'info':
        return 'fa-info-circle';
      default:
        return 'fa-question-circle';
    }
  }
}
